// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"e9362117","124":"eb588ffb","352":"3962c79b","414":"22f3aa76","453":"ccf60525"}[chunkId] + ".chunk.css";
};